import { useState, useEffect } from "react";
import AddEditProject from "./AddEditProject";
import moment from "moment";

const ProjectTrackRecord = (props) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("ongoing");
  const [selectedTypeForAdd, setSelectedTypeForAdd] = useState("");
  const [projectId, setProjectId] = useState({});
  const [projectListOngoing, setProjectListOngoing] = useState([]);
  const [projectListCompleted, setProjectListCompleted] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [projectTractRecordList, setProjectTrackRecordList] = useState([]);
  const [projectTrackRecords, setEditingProjectDetails] = useState({});
  const [editModel, setEditModel] = useState({});

  // Sync with props
  useEffect(() => {
    setProjectListOngoing(props.ongoingProjectTrackRecordsDetailsList || []);
    setProjectListCompleted(props.completedProjectTrackRecordsDetailsList || []);
  }, [props.ongoingProjectTrackRecordsDetailsList, props.completedProjectTrackRecordsDetailsList]);

  useEffect(() => {
    
    if (!modalOpen) {
      props.resetAllProjectTractRecordsFields();
    }
  }, [modalOpen]);
  const openModal = (type) => {
    setSelectedTypeForAdd(type);
    setEditModel(false);
    setModalOpen(true);
  };

  const handleRadioChange = (option) => {
    setSelectedOption(option);
    props.setProjectTypeFlags?.({
      isOngoingProject: option === "ongoing",
      isCompletedProject: option === "completed",
    });
  };

  const handleReset = () => {
    setModalOpen(false);
  };

  const handleSaveProject = (newProject) => {
    // Step 1: Set project flags
    newProject.isOngoing = selectedOption === "ongoing";
    newProject.isCompleted = selectedOption === "completed";
    const selectedOptionValue = newProject.isOngoing ? "ongoing" : "completed";

    // Step 2: Look for existing project by ID
    const projectList = props.projectTrackRecordsDetailsList || [];

    const selected = projectList.find(p => {
      return selectedOptionValue === "ongoing"
        ? p.ongoingProjectID === newProject.ongoingProjectID
        : p.completedProjectID === newProject.completedProjectID;
    });

    // Optional: Log for debugging
    console.log("New Project:", newProject);
    console.log("Selected from list:", selected);

    // Defensive check to avoid runtime errors
    const ongoingProjectId = selected?.ongoingProjectID || newProject.ongoingProjectID || null;
    const completedProjectId = selected?.completedProjectID || newProject.completedProjectID || null;

    const projectId = selectedOption === "ongoing" ? ongoingProjectId : completedProjectId;
    setProjectId(projectId);

    // Step 3: Add to lists based on flag
    if (selectedOption === "ongoing") {
      // setProjectListOngoing(prev => [...prev, newProject]);
    } else if (selectedOption === "completed") {
      // setProjectListCompleted(prev => [...prev, newProject]);
    }

    // Step 4: Add to combined list
    const updatedCombinedList = [...projectList, newProject];
    setProjectList(updatedCombinedList);
    setProjectTrackRecordList(updatedCombinedList, projectId);

    // Step 5: Propagate to parent
    props.AddEditProjectTrackRecord(newProject);

    // Step 6: Reset form

  };

  const handleEdit = async (id, onGoingProject) => {
    setEditModel(true);
    const isOngoing = onGoingProject === "Ongoing";
    const selectedOptionValue = isOngoing ? "ongoing" : "completed";
    setSelectedOption(selectedOptionValue);
    setSelectedTypeForAdd(selectedOptionValue);
    const selected = props.projectTrackRecordsDetailsList.find(p => {
      return selectedOptionValue === "ongoing"
        ? p.ongoingProjectID === id
        : p.completedProjectID === id;
    });

    if (!selected) {
      alert("Project not found for ID: " + id);
      return;
    }

    const projectIdToSet = isOngoing
      ? selected.ongoingProjectID
      : selected.completedProjectID;

    setProjectId(projectIdToSet);

    props.getProjectTrackrecordsDetailById(
      selected.ongoingProjectID,
      selected.completedProjectID,
      isOngoing,
      false
    );

    setModalOpen(true);
  };

  const handleDelete = async (id, onGoingProject) => {
    const isOngoing = onGoingProject === "Ongoing";
    const selectedOptionValue = isOngoing ? "ongoing" : "completed";
    setSelectedOption(selectedOptionValue);

    const selected = props.projectTrackRecordsDetailsList.find(p => {
      return selectedOptionValue === "ongoing"
        ? p.ongoingProjectID === id
        : p.completedProjectID === id;
    });

    if (!selected) {
      alert("Project not found for ID: " + id);
      return;
    }

    props.getProjectTrackrecordsDetailById(
      selected.ongoingProjectID,
      selected.completedProjectID,
      isOngoing,
      true
    );
  };

  const renderOngoingTable = () => {
    if (!projectListOngoing?.length) return null;

    return (
      <div className="bg-white p-6 mt-2">
        <h2 className="text-xl text-[#000000] mt-2 mb-3">Ongoing Project List</h2>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead className="bg-[#e78e3c] text-white">
              <tr>
                <th className="py-3 px-4">Contract No</th>
                <th className="py-3 px-4">Project Title</th>
                {/* <th className="py-3 px-4">Location</th> */}
                <th className="py-3 px-4">Project Type</th>
                <th className="py-3 px-4">Agency</th>
                <th className="py-3 px-4">Commencement</th>
                <th className="py-3 px-4">Expected Date of Completion</th>
                <th className="py-3 px-4">Award Value</th>
                <th className="py-3 px-4">Main Contractor Name</th>
                <th className="py-3 px-4">Main Contractor Telephone No</th>
                <th className="py-3 px-4">Main Contractor Email</th>
                <th className="py-3 px-4">Contact Person Name</th>
                <th className="py-3 px-4">Action</th>
              </tr>
            </thead>
            <tbody>
              {projectListOngoing.map((proj, index) => (
                <tr key={index} className="bg-gray-100 border-t">
                  <td className="py-2 px-4">{proj.contractNo}</td>
                  <td className="py-2 px-4">{proj.projectTitle}</td>
                  {/* <td className="py-2 px-4">{proj.projectLocation}</td> */}
                  <td className="py-2 px-4">{proj.projectType}</td>
                  <td className="py-2 px-4">{proj.agency}</td>
                  <td className="py-2 px-4">{proj.dateOfCommencement ? moment(proj.dateOfCommencement).format("DD-MM-YYYY")
                    : "-"}
                  </td>

                  <td className="py-2 px-4">
                    {proj.dateofCompletion
                      ? moment(proj.dateofCompletion).format("DD-MM-YYYY")
                      : "-"}
                  </td>
                  <td className="py-2 px-4">{proj.awardValue}</td>
                  <td className="py-2 px-4">{proj.mainContractorName}</td>
                  <td className="py-2 px-4">{proj.mainContractorTelephoneNo}</td>
                  <td className="py-2 px-4">{proj.mainContractorEmail}</td>
                  <td className="py-2 px-4">{proj.contactPersonName}</td>
                  <td className="py-2 px-4">
                    <div className="flex gap-4">
                      <button onClick={() => handleEdit(proj.ongoingProjectID, "Ongoing")} className="action-btn-edit mr-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          viewBox="0 0 26 26"
                        >
                          <path
                            fill="currentColor"
                            d="M20.094.25a2.25 2.25 0 0 0-1.625.656l-1 1.031l6.593 6.625l1-1.03a2.32 2.32 0 0 0 0-3.282L21.75.937A2.36 2.36 0 0 0 20.094.25m-3.75 2.594l-1.563 1.5l6.875 6.875L23.25 9.75zM13.78 5.438L2.97 16.155a.98.98 0 0 0-.5.625L.156 24.625a.975.975 0 0 0 1.219 1.219l7.844-2.313a.98.98 0 0 0 .781-.656l10.656-10.563l-1.468-1.468L8.25 21.813l-4.406 1.28l-.938-.937l1.344-4.593L15.094 6.75zm2.375 2.406l-10.968 11l1.593.343l.219 1.47l11-10.97z"
                          />
                        </svg>
                      </button>
                      <button onClick={() => handleDelete(proj.ongoingProjectID, "Ongoing")} className="action-btn-delete mr-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          viewBox="0 0 32 32"
                        >
                          <path
                            fill="currentColor"
                            d="M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.508L24.6 25.568A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.432L5.508 9H4a1 1 0 0 1 0-2zM9.388 25.34a3 3 0 0 0 2.98 2.66h7.263a3 3 0 0 0 2.98-2.66L24.48 9H7.521zM13 12.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0z"
                          />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const renderCompletedTable = () => {
    if (!projectListCompleted?.length) return null;

    return (
      <div className="bg-white p-6 mt-5">
        <h2 className="text-xl text-[#000000] mt-2 mb-3">Completed Project List</h2>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead className="bg-[#e78e3c] text-white">
              <tr>
                <th className="py-3 px-4">Contract No</th>
                <th className="py-3 px-4">Project Title</th>
                <th className="py-3 px-4">Project Type</th>
                <th className="py-3 px-4">Agency</th>
                {/* <th className="py-3 px-4">Location</th> */}
                <th className="py-3 px-4">Date Of Commencement</th>
                <th className="py-3 px-4">Actual Date of Completion</th>
                <th className="py-3 px-4">Award Value</th>
                <th className="py-3 px-4">Main Contractor Name</th>
                <th className="py-3 px-4">Main Contractor Telephone No</th>
                <th className="py-3 px-4">Main Contractor Email</th>
                <th className="py-3 px-4">Contact Person Name</th>
                <th className="py-3 px-4">Action</th>
              </tr>
            </thead>
            <tbody>
              {projectListCompleted.map((proj, index) => (
                <tr key={index} className="bg-gray-100 border-t">
                  <td className="py-2 px-4">{proj.contractNo}</td>
                  <td className="py-2 px-4">{proj.projectTitle}</td>
                  <td className="py-2 px-4">{proj.projectType}</td>
                  <td className="py-2 px-4">{proj.agency}</td>
                 {/* <td className="py-2 px-4">{proj.projectLocation}</td> */}
                  <td className="py-2 px-4">{proj.dateOfCommencement ? moment(proj.dateOfCommencement).format("DD-MM-YYYY")
                    : "-"}
                  </td>

                  <td className="py-2 px-4">
                    {proj.actualDateOfCompletion
                      ? moment(proj.actualDateOfCompletion).format("DD-MM-YYYY")
                      : "-"}
                  </td>
                  <td className="py-2 px-4">{proj.awardValue}</td>
                  <td className="py-2 px-4">{proj.mainContractorName}</td>
                  <td className="py-2 px-4">{proj.mainContractorTelephoneNo}</td>
                  <td className="py-2 px-4">{proj.mainContractorEmail}</td>
                  <td className="py-2 px-4">{proj.contactPersonName}</td>
                  <td className="py-3 px-9">
                    <div className="flex gap-4">
                      <button onClick={() => handleEdit(proj.completedProjectID, "Completed")} className="action-btn-edit mr-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          viewBox="0 0 26 26"
                        >
                          <path
                            fill="currentColor"
                            d="M20.094.25a2.25 2.25 0 0 0-1.625.656l-1 1.031l6.593 6.625l1-1.03a2.32 2.32 0 0 0 0-3.282L21.75.937A2.36 2.36 0 0 0 20.094.25m-3.75 2.594l-1.563 1.5l6.875 6.875L23.25 9.75zM13.78 5.438L2.97 16.155a.98.98 0 0 0-.5.625L.156 24.625a.975.975 0 0 0 1.219 1.219l7.844-2.313a.98.98 0 0 0 .781-.656l10.656-10.563l-1.468-1.468L8.25 21.813l-4.406 1.28l-.938-.937l1.344-4.593L15.094 6.75zm2.375 2.406l-10.968 11l1.593.343l.219 1.47l11-10.97z"
                          />
                        </svg>
                      </button>
                      <button onClick={() => handleDelete(proj.completedProjectID, "Completed")} className="action-btn-delete mr-4">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          viewBox="0 0 32 32"
                        >
                          <path
                            fill="currentColor"
                            d="M13.5 6.5V7h5v-.5a2.5 2.5 0 0 0-5 0m-2 .5v-.5a4.5 4.5 0 1 1 9 0V7H28a1 1 0 1 1 0 2h-1.508L24.6 25.568A5 5 0 0 1 19.63 30h-7.26a5 5 0 0 1-4.97-4.432L5.508 9H4a1 1 0 0 1 0-2zM9.388 25.34a3 3 0 0 0 2.98 2.66h7.263a3 3 0 0 0 2.98-2.66L24.48 9H7.521zM13 12.5a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0z"
                          />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="col-span-12">
      {/* Radio Buttons */}
      <div className="mt-2 flex items-center space-x-6">
        <label className="inline-flex items-center">
          <input
            type="radio"
            name="projectType"
            value="ongoing"
            checked={selectedOption === "ongoing"}
            onChange={() => handleRadioChange("ongoing")}
            className="form-radio h-5 w-5 text-blue-600"
          />
          <span className="ml-2 text-gray-800 text-base">Ongoing</span>
        </label>
        <label className="inline-flex items-center">
          <input
            type="radio"
            name="projectType"
            value="completed"
            checked={selectedOption === "completed"}
            onChange={() => handleRadioChange("completed")}
            className="form-radio h-5 w-5 text-green-600"
          />
          <span className="ml-2 text-gray-800 text-base">Completed</span>
        </label>
      </div>

      {/* Add Button */}
      {selectedOption && (
        <div className="mt-4">
          <button
            className="bg-orange-400 hover:bg-orange-600 text-white px-4 py-2 rounded"
            onClick={() => openModal(selectedOption)}
          >
            + Add {selectedOption === "ongoing" ? "Ongoing" : "Completed"} Project
          </button>
        </div>
      )}

      {/* Separate Tables */}
      {renderOngoingTable()}
      {renderCompletedTable()}

      {/* Modal */}
      <AddEditProject
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        closeModal={() => {
          setModalOpen(false);
          props.resetAllProjectTractRecordsFields();
        }}
        editModel={editModel}
        newProject={{}}
        handleChange={props.handleChange}
        validState={props.validState}
        isOngoing={
          props.projectTrackRecordsDetails?.isOnGoing === true
            ? true
            : selectedTypeForAdd === "ongoing"
        }
        isCompleted={
          props.projectTrackRecordsDetails?.isCompleted === true
            ? true
            : selectedTypeForAdd === "completed"
        }
        handleFileUpload={props.handleFileUpload}
        projectTrackRecordsDetails={props.projectTrackRecordsDetails}
        onFileChange={props.onFileChange}
        onSave={props.AddEditProjectTrackRecord}
        handleSave={handleSaveProject}
        handleChangeInDropdown={props.handleChangeInDropdown}
        projectTypelist={props.projectTypelist}
        SLOTSApplicationDetails={props.SLOTSApplicationDetails}
        letterofAwardorPurchaseOrderList={props.letterofAwardorPurchaseOrderList}
        certificateofcompletionList={props.certificateofcompletionList}
        finalInvoiceFilePathList={props.finalInvoiceFilePathList}
        GetSlotsMemberFiles={props.GetSlotsMemberFiles.bind(this)}
        deleteFile={props.deleteFile.bind(this)}
        validateField={props.validateField}
        validStateProjectTrackRecord={props.validStateProjectTrackRecord}
      />
    </div>
  );
};

export default ProjectTrackRecord;
